import complaintsProblemForm from './complaints-problem-form/complaints-problem-form.vue';
import { mapActions, mapState, mapGetters } from 'vuex';
import store from '../../../common/js/vuex/store';
import { ROUTE_NAMES } from '../constants/complaint-constants';

export default {
	props: {
		privacyPolicyUrl: {
			required: false
		},
		complaintPolicyUrl: {
			required: false
		}
	},
	components: {
		complaintsProblemForm
	},
	computed: {
		...mapState('complaints', [
			'initData',
			'captcha',
			'problemData',
			'captchaValidated',
			'visitedPages',
			'captchaBackendError',
			'loading'
		]),
		...mapGetters('complaints', ['lastVisitedPage'])
	},
	methods: {
		...mapActions('complaints', ['uploadFile', 'submitProblemForm', 'deleteFile'])
	},
	beforeRouteLeave(to, from, next) {
		let isPageTheLastVisited = this.lastVisitedPage == from.path;
		let toPathIsValid = store.state.complaints.validPages.indexOf(to.path) > -1;
		if (this.$refs['complaints-problem-form'].isFormInvalid()) {
			store.dispatch('complaints/removeValidPages', from.path);
			if (!isPageTheLastVisited || !toPathIsValid) {
				this.$refs['complaints-problem-form'].jumpToFirstError();
				next(false);
			} else {
				next();
			}
		} else {
			store.dispatch('complaints/addValidPages', from.path);
			this.$refs['complaints-problem-form'].postForm().then(
				(redirectToSecondPage) => {
					if (redirectToSecondPage) {
						next({ path: ROUTE_NAMES.PERSONAL, query: { scrollError: true } });
					} else {
						next();
					}
				},
				() => {
					next(false);
				}
			);
		}
	},
	beforeRouteEnter(to, from, next) {
		if (
			to.path == ROUTE_NAMES.PROBLEM ||
			store.state.complaints.validPages.indexOf(from.path) != -1 ||
			from.path == ROUTE_NAMES.SUMMARY
		) {
			store.dispatch('complaints/addVisitedPage', to.path);
			store.dispatch('complaints/setCurrentPage', to.path);
			next();
		} else {
			next(ROUTE_NAMES.PROBLEM);
		}
	}
};
